import { iconChecked, iconUnchecked } from '~/constants/customLegendsIcons'
import { EventBus } from '~/utils/eventBus'
import { useEventBus } from '~/composables/useEventBus'

export const getOrCreateContainer = (id, classes) => {
  const legendContainer = document.getElementById(id)
  let divContainer = legendContainer.querySelector('div')

  if (!divContainer) {
    divContainer = document.createElement('div')
    divContainer.classList.add(...classes)

    legendContainer.appendChild(divContainer)
  }

  return divContainer
}

export const setDatasetVisibility = (chart) => {
  const { emit } = useEventBus()
  const hashes = chart.data.datasets
    .filter((_dataset, index) => chart.isDatasetVisible(index))
    .map((dataset) => dataset.hash)
  emit('setDatasetVisibility', { hashes })
}

const getBackgroundColor = (legendType, item) => {
  if (item.hidden) {
    return '#CACBD3'
  }

  return legendType === 'capacity' ? item.fillStyle : item.strokeStyle
}

const getClassText = (legendType) => {
  const classes = ['text-gray-900', 'mr-2', 'font-semibold', 'text-sm']
  if (legendType === 'capacity') {
    classes.push('w-min', 'text-right')
  } else {
    classes.push('w-auto')
  }

  return classes
}

export const generateLegends = (
  chart,
  options,
  legendType,
  classes = ['flex', 'flex-wrap', 'gap-6'],
) => {
  const container = getOrCreateContainer(options.containerID, classes)
  // Remove old legend items
  while (container.firstChild) {
    container.firstChild.remove()
  }

  // Reuse the built-in legendItems generator
  const items = chart.options.plugins.legend.labels.generateLabels(chart)

  items.forEach((item) => {
    const checked = !item.hidden ? 'checked' : ''
    const iconBackground = !item.hidden ? iconChecked : iconUnchecked
    const backgroundColor = getBackgroundColor(legendType, item)

    const principalContainer = document.createElement('div')
    principalContainer.classList.add('flex', 'flex-col')
    principalContainer.setAttribute('id', `id-container--${item.text}`)

    const label = document.createElement('label')
    label.setAttribute('for', `id--${item.text}`)
    label.classList.add('flex', 'cursor-pointer', 'items-center', 'w-max')

    const div4 = document.createElement('div')
    div4.classList.add(...getClassText(legendType))
    div4.innerHTML = item.text

    const divContainer = document.createElement('div')
    divContainer.classList.add('relative')

    const input = document.createElement('input')
    input.setAttribute('id', `id--${item.text}`)
    input.setAttribute('type', 'checkbox')
    input.checked = !item.hidden
    input.classList.add('peer', 'sr-only')

    const circleClassColor =
      chart.getDatasetMeta(item.datasetIndex)?._dataset?.circleClassColor ??
      'bg-grey-900'

    const checkClassColor =
      chart.getDatasetMeta(item.datasetIndex)?._dataset?.checkClassColor ??
      'text-grey-900'

    const div = document.createElement('div')
    div.classList.add('block', 'rounded-full', 'bg-grey-400')
    div.style.width = '44px'
    div.style.height = '24px'
    div.style.backgroundColor = backgroundColor

    const div2 = document.createElement('div')
    div2.style.display = 'flex'
    div2.style.paddingTop = '2.5px'
    div2.style.paddingLeft = '1px'
    div2.style.paddingRight = '1.6px'

    if (checked) {
      div2.classList.add(checkClassColor)
      div2.classList.add('justify-start')
      input.setAttribute('checked', checked)
    } else {
      div2.classList.add('text-grey-900')
      div2.classList.add('justify-end')
      input.removeAttribute('checked')
    }

    div2.innerHTML = iconBackground

    div.appendChild(div2)

    const div3 = document.createElement('div')
    div3.classList.add('simple-toggle-circle')

    if (checked) {
      div3.classList.add(circleClassColor)
    } else {
      div3.classList.add('bg-grey-900')
    }

    divContainer.appendChild(input)
    divContainer.appendChild(div)
    divContainer.appendChild(div3)

    label.appendChild(div4)
    label.appendChild(divContainer)

    principalContainer.appendChild(label)

    label.onclick = () => {
      chart.setDatasetVisibility(
        item.datasetIndex,
        !chart.isDatasetVisible(item.datasetIndex),
      )
      if (legendType === 'capacity') {
        EventBus.$emit('toggleOnChart', item.text)
      }
      chart.update()
      setDatasetVisibility(chart)
    }

    container.appendChild(principalContainer)
  })
}
